import React from 'react';
import {Modal,message} from 'antd';
import _ from 'lodash';


let {URL} = window.config;
var isShow = false,ismodalshow= false
function windowResize (callback) {
	
	window.onresize = function () {
		callback && callback()
	}
}

// 全局提示
const modalInfo = (title, content, okText) => {
	if(ismodalshow == true) return
	ismodalshow = true
	let info = Modal.info({
		title: title,
		content: content,
		okText: okText || '知道了',
		onOk: ()=>{ismodalshow = false}
	})
}
message.config({
  duration: 3,
});
const successMsg = (msg, time) => {
	if(isShow == true) return
	isShow = true
	message.success(msg,3);
	setTimeout(() => {
		// info.destroy()
		isShow = false
	}, 3000)
}

const errorMsg = (msg) => {
    message.error(msg,5);
//   let info = Modal.error({
// 		title: '消息提示',
// 		content: msg
// 	})
  
}
const warningMsg = (msg, time) => {
	// time = time || 2000
  	// let info = Modal.warning({
	// 	title: '消息提示',
	// 	content: msg,
	// })
  if(isShow == true) return
	isShow = true
	message.warning(msg,3);
	setTimeout(() => {
		// info.destroy()
		isShow = false
	}, 3000)
}

// 保存confirm的modal
let confirmModalArr = []

const confirmModal = (okCallback, cancelCallback, msg) => {
	if(isShow) return
	isShow = true
	let info = Modal.confirm({
			title: '消息提示',
			content: msg,
			onOk: okCallback,
			//onCancel: cancelCallback,
			okText: '确定',
			okType: 'primary',
			//cancelText: '取消',
			//cancelType: 'default'
		})
	confirmModalArr.push(info)
	
}

//缓存封装
let localManage = {
	setItem:function(key,value){
		if(typeof value === 'object') {
			value = JSON.stringify(value)
		}
	    localStorage.setItem(key,value);
	}, 
	getItem:function(key){
		let item = localStorage.getItem(key) || ''
		if(item.indexOf('[') === 0 || item.indexOf('{') === 0) {
			item = JSON.parse(item)
		}
	    return  item;
	},
	removeItem:function(key){
	    localStorage.removeItem(key);
	}
};
let sessionManage = {
	setItem: function (key, value) {
		if (typeof value === 'object') {
			value = JSON.stringify(value);
		}
		sessionStorage.setItem(key, value);
	},
	getItem: function (key) {
		let item = sessionStorage.getItem(key) || '';
		if (item.indexOf('[') === 0 || item.indexOf('{') === 0) {
			item = JSON.parse(item);
		}
		return item;
	},
	removeItem: function (key) {
		sessionStorage.removeItem(key);
	},
};


let errorCode = (code)=>{
	var msg
	if(code == '500'){
		msg = '请联系管理员'
	}else if(code == '001'){
		msg = '参数错误'
	}else if(code == '002'){
		msg = '没有数据'
	}else if(code == '003'){
		msg = '违法唯一约束'
	}else if(code == '004'){
		msg = '禁止操作'
	}else if(code == '401'){
		msg = '无权限'
	}else{
		msg = '未登录'
	}
	
	if(isShow == true) return
	isShow = true
	message.error(msg,3)
	setTimeout(()=>{
		isShow = false
	},3000)
}
// 时间戳转换
let add0=(m)=>{return m<10?'0'+m:m }
let	timeFormat=(timestamp,index,isYMD)=>{
	if(timestamp){
		var time = new Date(timestamp);
		var year = time.getFullYear();
		var month = time.getMonth()+1;
		var date = time.getDate();
		var hours = time.getHours();
		var minutes = time.getMinutes();
		if(index){
			var seconds = time.getSeconds();
			return year+'-'+add0(month)+'-'+add0(date)+' '+add0(hours)+':'+add0(minutes)+':'+add0(seconds);
		}else if(isYMD){
			return year+'-'+add0(month)+'-'+add0(date)
		}else{
			return year+'-'+add0(month)+'-'+add0(date)+' '+add0(hours)+':'+add0(minutes)
		}
	}
}
let AirportTime = (timestamp)=>{
	if(timestamp){
		var time = new Date(timestamp);
		var hours = time.getHours();
		var minutes = time.getMinutes();
		return add0(hours)+''+add0(minutes)
	}
}


 
let loadingDom = document.getElementById('loading')
function showLoading (str) {
	if(window.getComputedStyle(loadingDom, null).display === 'block') {
		return
	}
	
	str = str || 'Loading...'
	document.getElementById('loadingText').innerHTML = str
	loadingDom.style.display = 'block'	
}

// 取出两个数组的不同元素
let getArrDifference=(arr1, arr2) =>{
        return arr1.concat(arr2).filter(function(v, i, arr) {
            return arr.indexOf(v) === arr.lastIndexOf(v);
        });
    }
// 取出两个数组的相同元素
let getArrEqual=(arr1, arr2)=> {
    let newArr = [];
    for (let i = 0; i < arr2.length; i++) {
        for (let j = 0; j < arr1.length; j++) {
            if(arr1[j] === arr2[i]){
                newArr.push(arr1[j]);
            }
        }
    }
    return newArr;
}


// 对象克隆
let clone=(obj)=>{
    let temp = null;
    if(obj instanceof Array){
        temp = obj.concat();
    }else if(obj instanceof Function){
        //函数是共享的是无所谓的，js也没有什么办法可以在定义后再修改函数内容
        temp = obj;
    }else{
        temp = new Object();
        for(let item in obj){
            let val = obj[item];
            temp[item] = typeof val == 'object'?clone(val):val; //这里也没有判断是否为函数，因为对于函数，我们将它和一般值一样处理
        }
    }
    return temp;
}

function hideLoading () {
	loadingDom.style.display = 'none'
}



const globalService = {
    localManage,
    sessionManage,
    modalInfo,
    successMsg,
    errorMsg,
    warningMsg,
	timeFormat,
	AirportTime,
	showLoading,
	getArrDifference,
	getArrEqual,
	clone,
}

export default globalService
